import { ValidateApplicationPolicyReqDto } from "src/configs/APISchemas/ValidateUserPolicyGraphQL";
import { VerifyPolicyInput } from "src/redux/reducer/v2/verifyPolicy";

type OptionParams = { isExistingUnit: boolean; isSkipUnitNumber: boolean };

export function validateApplicationPolicySerializer(
  values: VerifyPolicyInput,
  activeCovieLink: string | null,
  options: OptionParams,
  utmSource: string,
): ValidateApplicationPolicyReqDto {
  const { isExistingUnit, isSkipUnitNumber } = options;

  const buildingUnit = isExistingUnit ? values.unit?.name : values.buildingUnit;
  const unit = isSkipUnitNumber ? undefined : buildingUnit;

  return {
    address: values.address,
    email: values.email,
    firstName: values.firstName,
    lastName: values.lastName,
    leaseStart: values.leaseStart || '',
    leaseEnd: values.leaseEnd || '',
    buildingId: values.buildingId,
    buildingUnit: unit,
    linkId: activeCovieLink,
    utmSource,
  };
}
